var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: 0 },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _vm.checkPermi(["merchant:member:level:add"])
            ? _c(
                "el-button",
                {
                  staticClass: "mt20 ml20",
                  attrs: {
                    size: "small",
                    type: "primary",
                    disabled: _vm.tableData.data.length === 10 ? true : false,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleEditLevel(0)
                    },
                  },
                },
                [_vm._v("添加等级")]
              )
            : _vm._e(),
          _c("base-table", {
            ref: "table",
            attrs: {
              loading: _vm.listLoading,
              "table-data": _vm.tableData,
              columns: _vm.tableColumns,
              showPagination: false,
            },
            scopedSlots: _vm._u([
              {
                key: "interests",
                fn: function (ref) {
                  var row = ref.row
                  return _vm._l(row.benefits.split(","), function (benefitId) {
                    return _c(
                      "div",
                      { key: benefitId, staticClass: "benefit-item" },
                      [
                        _vm.getBenefitById(benefitId) &&
                        _vm.getBenefitById(benefitId).selectedIcon
                          ? _c("el-image", {
                              staticClass: "benefit-icon mr5",
                              attrs: {
                                src: _vm.getBenefitById(benefitId).selectedIcon,
                              },
                            })
                          : _vm._e(),
                        _c("span", { staticClass: "benefit-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.getBenefitById(benefitId) &&
                                _vm.getBenefitById(benefitId).name
                            )
                          ),
                        ]),
                      ],
                      1
                    )
                  })
                },
              },
              {
                key: "operate",
                fn: function (ref) {
                  var row = ref.row
                  var index = ref.index
                  return [
                    _vm.checkPermi(["merchant:member:level:update"])
                      ? _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.handleEditLevel(1, row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        )
                      : _vm._e(),
                    _vm.isShowEdit(index)
                      ? [
                          _c("el-divider", {
                            attrs: { direction: "vertical" },
                          }),
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.handleDeleteLevel(row.id)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm.editDialogConfig.visible
        ? _c("edit-level", {
            attrs: {
              editDialogConfig: _vm.editDialogConfig,
              level: _vm.tableData.data.length + 1,
            },
            on: {
              "update-success": _vm.getList,
              "update-close": _vm.handleClose,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }